import { createContext, Dispatch, useContext } from 'react'
import { GoodwillfindsListing } from '../../../../types/api/listings'
import { GoodwillfindsRequirements } from '../../../products_v5/components/JoinedForm/types'

interface GoodwillfindsChannelFormContextValues {
  errors: any
  form: GoodwillfindsListing
  onListingChange: (nameValue: any) => void // TODO: this could be typed more clearly, but I couldn't figure it out: (keyNameAndValueObject: { name: string; value: any } | { name: string; value: any }[]) => void
  localErrors: any
  setLocalErrors: Dispatch<any>
  templateForm: any // builder template form for possible autofill attributes
  productSupplierId?: string
  goodwillfindsRequirements: GoodwillfindsRequirements
  setGoodwillfindsRequirements: (goodwillfindsRequirements: GoodwillfindsRequirements) => void
}
export const GoodwillfindsChannelFormContext = createContext<GoodwillfindsChannelFormContextValues>({
  errors: null,
  form: null,
  onListingChange: _e => {},
  localErrors: {},
  setLocalErrors: () => {},
  templateForm: null,
  productSupplierId: null,
  goodwillfindsRequirements: { specifics: [] },
  setGoodwillfindsRequirements: _goodwillfindsRequirements => {}
})
export const useGoodwillfindsChannelFormContext = () => useContext(GoodwillfindsChannelFormContext)
